export const COLORS = {
  primary: '#275C4A',
  secondary: '#DBDBDB',
};
